import React, {useEffect, useState} from 'react';
import {Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import {report_strings} from "../../translations/report_translations";
import CashierTransactionRow from "../reports/CahierTransactionRow";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);
let reportStrings = new LocalizedStrings(report_strings);

const CashierIncomesTable = (props) => {
    const [transactions, setTransactions] = useState(props.transactions);
    const [addedTransactions, setAddedTransactions] = useState(props.addedTransactions);
    const [updatedTimes, setUpdatedTimes] = useState(props.tablesUpdatedTimes);

    useEffect(() => {
        if (props.transactions !== transactions) {
            setTransactions(props.transactions)
        }
    });

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
    }

    localize();

    function calculateIfAdded(transaction) {
        const res = addedTransactions.includes(JSON.stringify(transaction))
        return res
    }

    function renderTransactionTable() {
        if (transactions != null && transactions.length > 0) {
            return transactions.map((transaction, index) => {
                transaction.added = calculateIfAdded(transaction)
                return (
                    <CashierTransactionRow
                        transaction={transaction} key={transaction.id}
                        currency={props.currency}
                        type="income"
                        addTransaction={addTransaction}
                        removeTransaction={removeTransaction}
                    />
                )
            })
        }
        else {
            return <h4 className="text-white"> {reportStrings.no_transactions_for_day} </h4>
        }
    }

    function addTransaction(e, transaction, type) {
        e.preventDefault();
        props.addTransaction(transaction, type)
    }

    function removeTransaction(e, transaction, type) {
        e.preventDefault();
        props.removeTransaction(transaction, type)
    }

    return (
        <>
            <Table
                className="align-items-center table-dark table-flush"
                responsive
            >
                <thead className="thead-dark">
                <tr>
                    <th scope="col"> {resourceStrings.title} </th>
                    <th scope="col"> {commonStrings.payment_method} </th>
                    <th scope="col"> {resourceStrings.amount} </th>
                    <th scope="col"/>
                </tr>
                </thead>
                <tbody>
                {renderTransactionTable()}
                </tbody>
            </Table>
        </>
    );
};

export default CashierIncomesTable;